module.exports = __webpack_public_path__ + "img/iPhone 15.73649453.jpg";